import React from "react";
import { useHistory } from "react-router-dom";
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import GavelIcon from '@mui/icons-material/Gavel';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

export const ChartClientesJuridico = ({ data }) => {
  const history = useHistory();
  // console.log(data)
  const GetClass = (value, minimo = 20, medium = 81) => {
    if (value <= minimo) return "circle-red";
    else if (value <= medium) return "circle-yellow";
    else return "circle-success";
  };
  const handleClickEstadoResultado = () => {
    history.push("/Finanzas/EstadodeResultados");
  };

  const formatMiles = (number) => {
    return Math.floor((number ?? 0) / 1000).toLocaleString('en-US');
  };

  const calcularPorcentaje = (cantidad, total) => {
    if (!total) return "0.00";
    return ((cantidad / total) * 100).toFixed(2);
  };
  const totalCantidad = data.reduce((sum, item) => sum + item.cantidad, 0);

  const iconosPorEstatus = {
    "Pendiente": <HourglassBottomIcon />,
    "Revisión": <ManageSearchIcon />,
    "Cobranza": <AccountBalanceWalletIcon />,
    "Juridico": <GavelIcon />
  };

  return (
    <div className="clientes-juridico-container">
      <table cellPadding={0} cellSpacing={0}>
        <tbody>
          {data.map((item, index) => (
            <tr key={index} className={item.estatus === "Cobranza" ? "fw-bold" : ""}>
              <td>
                {iconosPorEstatus[item.estatus]}
                <span style={{ marginLeft: "4px" }}>{item.estatus}</span>
              </td>
              <td></td>
              <td>{item.cantidad}</td>
              <td>{calcularPorcentaje(item.cantidad, totalCantidad)} %</td>
              <td>$ {formatMiles(item.saldo)}</td>
            </tr>
          ))}
          <tr className="fw-bold">
            <td>
              <AttachMoneyIcon /> 
              <span style={{ marginLeft: "4px" }}>
                Total
              </span>
            </td>
            <td></td>
            <td>{totalCantidad}</td>
            <td>100 %</td>
            <td>$ {formatMiles(data.reduce((sum, item) => sum + item.saldo, 0))}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
